import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useEsignStore = defineStore('esignStore', {
	state: () => ({

	}),
	actions: {
		getEsignDetail(uuid) {
			return new Promise((resolve, reject) => {
				axios.get(services.esign + 'esign/detail?esign_uuid=' + uuid, {headers: getHeader()}).then(res => {
					if (!_gHlp.isEmpty(res.data)) {
						resolve(res.data);	
					} else {
						reject({});
					}
				}).catch(error => {
					_gNotif.errorFunction(error);
					reject(error); // Reject the Promise with the error
				});
			});
		}
	}
})